import { enumerable } from '@Common/Core/CoreDecorator';

if (!('DOMRect' in window && 'DOMRectReadOnly' in window)) {
    class DOMRectReadOnly implements DOMRectReadOnly {
        constructor(
            public readonly x: number = 0,
            public readonly y: number = 0,
            public readonly width: number = 0,
            public readonly height: number = 0
        ) {}

        @enumerable
        public get top(): number {
            return this.y;
        }

        @enumerable
        public get left(): number {
            return this.x;
        }

        @enumerable
        public get right(): number {
            return this.x + this.width;
        }

        @enumerable
        public get bottom(): number {
            return this.y + this.height;
        }

        static fromRect(otherRect: Pick<DOMRectReadOnly, 'x' | 'y' | 'width' | 'height'>) {
            return new DOMRect(otherRect.x, otherRect.y, otherRect.width, otherRect.height);
        }

        get [Symbol.toStringTag]() {
            return 'DOMRectReadOnly';
        }

        public toJSON(): Record<Exclude<keyof DOMRectReadOnly, 'toJSON'>, number> {
            return {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height,
                top: this.top,
                left: this.left,
                right: this.right,
                bottom: this.bottom
            };
        }
    }

    class DOMRect extends DOMRectReadOnly implements DOMRect {
        public x: number;
        public y: number;
        public width: number;
        public height: number;

        get [Symbol.toStringTag]() {
            return 'DOMRect';
        }
    }

    window.DOMRectReadOnly = DOMRectReadOnly;
    window.DOMRect = DOMRect;
}
